/**
 * Sticky add to cart con anuncio integrado — Apodemia
 * Aparece cuando ya se ha pasado (hacia abajo) el botón principal de compra de
 * la PDP y se esconde al volver a él o al llegar al footer. "Añadir" reutiliza el botón principal (variantes
 * y addons incluidos). El anuncio y el precio se recalculan al cambiar de
 * variante (evento pdp:variant): oferta → "Estás ahorrando X", stock bajo →
 * mensaje propio, si no → mensaje por defecto.
 */
(function () {
  'use strict';

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
  }

  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    var mainBtn = document.querySelector('[data-pdp-add-main]');
    if (!mainBtn) return; // sin PDP no hay sticky

    var annEl = bar.querySelector('[data-sticky-ann]');
    var nowEl = bar.querySelector('[data-sticky-now]');
    var wasEl = bar.querySelector('[data-sticky-was]');
    var priceWrap = bar.querySelector('[data-sticky-price]');
    var addBtn = bar.querySelector('[data-sticky-add]');

    var annDefault = bar.getAttribute('data-ann-default') || '';
    var annSale = bar.getAttribute('data-ann-sale') || '';
    var annLow = bar.getAttribute('data-ann-low') || '';
    var annFree = bar.getAttribute('data-ann-free') || '';
    // Umbral de envío gratis en céntimos de la moneda base -> moneda del visitante
    var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    var freeThreshold = (parseInt(bar.getAttribute('data-free-threshold'), 10) || 0) * rate;

    // Umbral de stock bajo (del bloque de stock de la PDP, si existe)
    var stockEl = document.querySelector('[data-pdp-stock]');
    var lowThreshold = stockEl ? (parseInt(stockEl.getAttribute('data-threshold'), 10) || 10) : 10;

    // --- Añadir: delega en el botón principal de la PDP --------------------
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        mainBtn.click();
      });
    }

    // --- Sincroniza precio + anuncio al cambiar de variante ---------------
    function apply(v) {
      if (!v) return;
      var price = v.price;
      var compare = v.compare || 0;
      var onSale = compare > price;

      if (nowEl && !v.initial) nowEl.textContent = money(price);
      if (wasEl && !v.initial) {
        if (onSale) { wasEl.textContent = money(compare); wasEl.hidden = false; }
        else { wasEl.hidden = true; }
      }

      var isLow = v.managed && v.qty > 0 && v.qty <= lowThreshold;
      var isFree = freeThreshold > 0 && price >= freeThreshold;
      var text;
      if (onSale && annSale) {
        text = annSale.replace('[ahorro]', money(compare - price));
      } else if (isFree && annFree) {
        text = annFree;
      } else if (isLow && annLow) {
        text = annLow;
      } else {
        text = annDefault;
      }
      if (annEl) annEl.textContent = text;

      if (addBtn) {
        addBtn.disabled = !v.available;
        if (typeof v.preorder === 'boolean') addBtn.textContent = addBtn.getAttribute(v.preorder ? 'data-label-pre' : 'data-label-add') || addBtn.textContent;
      }
      bar.classList.toggle('is-sale', onSale);
    }
    document.addEventListener('pdp:variant', function (e) { apply(e.detail); });
    // Estado inicial (con la moneda del visitante ya conocida en el navegador)
    apply({
      price: parseInt(bar.getAttribute('data-initial-price'), 10) || 0,
      compare: parseInt(bar.getAttribute('data-initial-compare'), 10) || 0,
      available: !(addBtn && addBtn.disabled),
      managed: null,
      qty: 0,
      initial: true // solo decide el anuncio; el precio ya viene del servidor
    });

    // --- Mostrar / ocultar -------------------------------------------------
    // Solo se muestra cuando el botón principal ya ha quedado POR ENCIMA de la
    // pantalla (se ha pasado). Si aún está por debajo (móvil al cargar), no.
    var mainPassed = false;
    var footerVisible = false;

    function update() {
      var show = mainPassed && !footerVisible;
      if (show) {
        bar.hidden = false;
        // fuerza reflow para la transición al pasar de hidden a visible
        void bar.offsetHeight;
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    }
    // Al terminar la transición de salida, oculta del todo.
    bar.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'transform' && !bar.classList.contains('is-visible')) {
        bar.hidden = true;
      }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        mainPassed = !e.isIntersecting && e.boundingClientRect.bottom <= 0;
        update();
      }, { rootMargin: '0px' }).observe(mainBtn);

      var footer = document.querySelector('.apodemia-footer') || document.querySelector('footer');
      if (footer) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[0].isIntersecting;
          update();
        }, { rootMargin: '0px' }).observe(footer);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
